export type ResultStep = 'mark' | 'steal' | 'done';

/**
 * Which prompt the phone shows on the reveal screen. Mark comes first (one tap); the steal
 * follows once the player has marked or has nothing left to mark.
 */
export function resultStep(o: {
  canMark: readonly unknown[];
  markedThisRound: number | null;
  /** The steal was earned (an exact year), even if it has since been used. */
  stealEarned: boolean;
  /** Seconds left in the mark window. */
  secsLeft: number;
  /** The steal window opens early once secsLeft is at or below this (5 s into the longer window). */
  stealAtSecs: number;
}): ResultStep {
  // Never marking must not lose the steal: after 5 s the server's auto-mark is a given.
  const markPending = o.canMark.length > 0 && o.markedThisRound === null && !(o.stealEarned && o.secsLeft <= o.stealAtSecs);
  if (markPending) return 'mark';
  return o.stealEarned ? 'steal' : 'done';
}
